<template>
  <div>
    <ManualOrder v-if="!loading" :edit="true"></ManualOrder>
  </div>
</template>

<script>
import ManualOrder from "@/components/ManualOrder";
import axios from "axios";

export default {
  name: "ManualEdit",
  components: { ManualOrder },
  data() {
    return {
      loading: true,
    };
  },
  mounted() {
    this.loading = true;
    axios
      .all([
        this.$http.get(
          "/orders/manual-order/" + this.$route.params.id + "/edit"
        ),
        // this.$store.dispatch("prepareMaterials"),
      ])
      .then(
        axios.spread((order) => {
          this.$store.commit("setEditData", order.data);
          this.loading = false;
        })
      );
     
  },
};
</script>

<style scoped>
</style>
